import Page from '../Pages/Page'
import { useParams, useHistory } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react'
import Spinner from '../Spinner/Spinner'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

const EditPost = () => {
	const { id } = useParams()
	const [post, setPost] = useState({})
	const [loading, setLoading] = useState(false)
	const history = useHistory()

	const token = JSON.parse(localStorage.getItem('user'))

	useEffect(() => {
		setLoading(true)
		fetch(`https://cp-node-api.herokuapp.com/api/posts/${id}`)
			.then((res) => res.json())
			.then((data) => [setPost(data), setLoading(false)])
	}, [])

	const handleThumbnailValue = (e) => {
		const postThumbValue = e.target.value
		const newPost = {
			thumbnail: postThumbValue,
			title: post.title,
			description: post.description,
		}

		setPost(newPost)
	}

	const handleTitleValue = (e) => {
		const postTitleValue = e.target.value
		const newPost = {
			thumbnail: post.thumbnail,
			title: postTitleValue,
			description: post.description,
		}

		setPost(newPost)
	}

	const handleDescValue = (e, editor) => {
		const postDescValue = editor.getData()
		const newPost = {
			thumbnail: post.thumbnail,
			title: post.title,
			description: postDescValue,
		}

		setPost(newPost)
	}

	const handlePostEdit = (e) => {
		e.preventDefault()

		fetch(`https://cp-node-api.herokuapp.com/api/posts/${id}`, {
			method: 'PUT',
			headers: {
				token: `Bearer ${token.accessToken}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(post),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data) {
					history.push('/posts')
				}
			})
	}

	return (
		<Page>
			{loading ? (
				<Spinner />
			) : (
				<section className='add-new'>
					<h4 className='mb-4'>Edit Post</h4>
					<form className='w-50' onSubmit={handlePostEdit}>
						<div className='form-group mb-3'>
							<img
								className='w-50 rounded mb-3'
								src={post.thumbnail}
								alt=''
							/>
							<input
								value={post.thumbnail || ''}
								onChange={handleThumbnailValue}
								className='form-control'
								type='text'
							/>
						</div>
						<div className='form-group mb-3'>
							<input
								value={post.title || ''}
								onChange={handleTitleValue}
								type='text'
								className='form-control'
								placeholder='Title'
							/>
						</div>
						<div className='form-group mb-3'>
							<CKEditor
								data={post.description}
								onChange={handleDescValue}
								editor={ClassicEditor}
							/>
						</div>
						<button className='btn btn-primary'>Update</button>
					</form>
				</section>
			)}
		</Page>
	)
}

export default EditPost
